export const parseDate = (value) => {
    const [d, m, y] = (value || "").split("/").map((part) => parseInt(part, 10))
    if (!d || !m || !y) return null
    const date = new Date(y, m - 1, d)
    if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null
    return date
}
